import { forwardRef, HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface SelectableCardProps extends HTMLAttributes<HTMLDivElement> {
  isSelected: boolean;
  title?: string;
  subheader?: ReactNode;
  wrapperClassName?: string;
}

export const SelectableCard = forwardRef<HTMLDivElement, SelectableCardProps>(
  (
    {
      isSelected,
      title,
      subheader,
      className,
      wrapperClassName,
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <div ref={ref} className={cn('w-full space-y-2', wrapperClassName)}>
        {title && (
          <h3 className="text-lg font-semibold text-center">{title}</h3>
        )}
        {subheader}
        <div
          className={cn(
            'w-full transition-all rounded-lg overflow-hidden ring-1',
            isSelected
              ? 'ring-2 ring-opacity-50 ring-primary'
              : 'ring-warm-gray-200',
            className,
          )}
          {...props}
        >
          {children}
        </div>
      </div>
    );
  },
);

SelectableCard.displayName = 'SelectableCard';
